// extracted by mini-css-extract-plugin
export default {"field":"EditAssignmentDialog_field__4NWFH","consequence":"EditAssignmentDialog_consequence__noVFn"};